<template>
  <v-app-bar color="#278B97" hide-on-scroll>
    <!-- CORREÇÃO NOVA: Botão hambúrguer para mobile -->
    <v-app-bar-nav-icon
      v-if="$vuetify.breakpoint.xsOnly"
      @click="toggleDrawer"
      color="white"
      aria-label="Abrir menu lateral"
    ></v-app-bar-nav-icon>

    <router-link to="/home">
      <img
        src="@/assets/images/espaco-colaborador/logo_nossa_hepta.png"
        alt="Nossa Hepta - pagina inicial"
      />
    </router-link>

    <v-spacer></v-spacer>

    <v-list-item v-for="item in menu" :key="item.id">
      <v-col>
        <router-link :to="item.link" class="link">{{ item.nome }}</router-link>
      </v-col>
    </v-list-item>
    <v-list-item light role="search">
      <v-btn
        v-if="!pesquisar"
        icon
        @click="pesquisar = true"
        aria-label="Abrir busca"
      >
        <v-icon color="white">fas fa-magnifying-glass</v-icon>
      </v-btn>
      <v-text-field
        v-else
        dense
        solo
        label="Pesquisar"
        aria-label="Pesquisar no Nossa Hepta"
        autofocus
        v-model="keyword"
        @keyup.enter="abrir('/pesquisa/' + keyword)"
        color="#278b97"
        hide-details="auto"
        clearable
        :class="$vuetify.breakpoint.lg ? 'search-field' : ''"
      >
        <template slot="append">
          <v-btn icon x-small @click="pesquisar = false" aria-label="Fechar busca">
            <v-icon color="#008B98">fas fa-magnifying-glass</v-icon>
          </v-btn>
        </template>
      </v-text-field>
    </v-list-item>
  </v-app-bar>
</template>

<script>
export default {
  data() {
    return {
      keyword: "",
      menu: [
        { nome: "Início", link: "/home" },
        { nome: "Novidades", link: "/novidades" },
        { nome: "#Jeito Hepta", link: "/jeitohepta" },
        { nome: "Biblioteca", link: "/biblioteca" },
        { nome: "Perguntas Frequentes", link: "/perguntas-frequentes" },
      ],
      pesquisar: false,
    };
  },
  methods: {
    abrir(path) {
      this.$router.push({
        path: path,
      });
    },
    /* 🟢 CORREÇÃO NOVA: Emite event bus para toggle o drawer */
    toggleDrawer() {
      this.$root.$emit("toggle-drawer");
    },
  },
};
</script>

<style scoped>
.v-app-bar {
  padding: 0 5%;
}

::v-deep .v-toolbar__content {
  overflow-x: auto;
  scrollbar-color: #278b97 #f5f5f5;
}

.v-list-item {
  flex: none;
}

.link {
  color: #fff !important;
  font-weight: 600;
  text-decoration: none;
}

.search-field {
  position: absolute;
  right: 0;
  min-width: 9rem;
  z-index: 1;
}

@media screen and (min-width: 601px) and (max-width: 1919px) {
  .v-app-bar {
    padding: 0;
    margin-bottom: 1rem;
  }

  ::v-deep .v-toolbar__content {
    height: 73px !important;
  }
}

@media screen and (max-width: 600px) {
  .v-app-bar {
    padding: 0;
  }
}
</style>
